(function () {
  var doc = document;
  doc.documentElement.classList.add('js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Afsløring ved scroll
  var targets = doc.querySelectorAll('[data-reveal], .uni, .amb__path');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  }

  // Mobilmenu
  var hdr = doc.querySelector('.hdr');
  var burger = doc.querySelector('.burger');
  if (hdr && burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    hdr.querySelectorAll('.nav a').forEach(function (a) {
      a.addEventListener('click', function () { hdr.classList.remove('is-open'); });
    });
  }

  // Manifest: ordene lyser op, mens man scroller
  doc.querySelectorAll('[data-scrub]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var spans = words.map(function (w, i) {
      var s = doc.createElement('span');
      s.className = 'w';
      s.textContent = w;
      el.appendChild(s);
      if (i < words.length - 1) el.appendChild(doc.createTextNode(' '));
      return s;
    });
    function update() {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = reduce ? spans.length : Math.round(p * spans.length);
      spans.forEach(function (s, i) { s.classList.toggle('on', i < n); });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  // Univers: klik på en node (eller en vælger) for at se løsningen
  doc.querySelectorAll('[data-universe]').forEach(function (root) {
    var nodes = root.querySelectorAll('.node');
    var ids = Array.prototype.map.call(nodes, function (n) { return n.getAttribute('data-pid'); });
    var current = 0, timer = null, inView = false, stopped = false;

    function select(id) {
      var idx = ids.indexOf(id);
      if (idx > -1) current = idx;
      root.querySelectorAll('[data-pid]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-pid') === id);
      });
      root.querySelectorAll('[data-select]').forEach(function (b) {
        var on = b.getAttribute('data-select') === id;
        b.classList.toggle('is-active', on && b.classList.contains('chip'));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function stop() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || stopped || timer || ids.length < 2) return;
      timer = setInterval(function () { select(ids[(current + 1) % ids.length]); }, 5500);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-select]');
      if (!b) return;
      stop();
      select(b.getAttribute('data-select'));
    });
    root.addEventListener('focusin', stop);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else if (timer) { clearInterval(timer); timer = null; }
      }, { threshold: 0.4 }).observe(root);
    }

    // Shopify theme editor: vælg blok => vis den
    doc.addEventListener('shopify:block:select', function (e) {
      var id = e.target && e.target.getAttribute && e.target.getAttribute('data-pid');
      if (id && root.contains(e.target)) { stop(); select(id); }
    });
  });
})();
